import gql from "graphql-tag";

export const STATIC_PAGE = gql`
  query getStaticPage($name: String!) {
    staticPage(name: $name) {
      name
      content
    }
  }
`;

export const FAQ_TOPICS = gql`
  query getFaqTopics {
    faqTopics {
      type
      entities {
        id
        title
        description
        updatedAt
      }
    }
  }
`;

export const FAQ_TOPIC = gql`
  query getFaqTopic($faqTopicId: Int!) {
    faqTopic(faqTopicId: $faqTopicId) {
      id
      title
      faqs {
        id
        question
        updatedAt
      }
    }
  }
`;

export const FAQ_TOPIC_SHORT = gql`
  query getFaqTopic($faqTopicId: Int!) {
    faqTopic(faqTopicId: $faqTopicId) {
      id
      title
    }
  }
`;

export const FAQ_DETAILS = gql`
  query getFaqDetails($id: ID!) {
    faq(id: $id) {
      id
      question
      answer
      updatedAt
      relatedArticles {
        id
        question
      }
    }
  }
`;

export const FAQ_SEARCH = gql`
  query getFAQSearch($input: String!, $page: Int!, $perPage: Int) {
    faqSearch(input: $input, page: $page, perPage: $perPage) {
      entities {
        faqTopic {
          id
          shortTitle
        }
        faq {
          id
          shortQuestion
          shortAnswer
        }
      }
      pagination {
        totalItems
        totalPages
        currentPage
        perPage
      }
    }
  }
`;

export const JOIN_PAGE = gql`
  query getJoinPageItems {
    joinPageItems {
      header {
        title
        text
        image
      }
      mainContent {
        title
        text
        image
      }
      howWeWork {
        title
        text
        image
      }
    }
  }
`;

export const CREATE_CONTACT_US = gql`
  mutation createContactUs(
    $name: String!
    $email: String!
    $messageSubject: String
    $phone: String
    $message: String!
  ) {
    contactUs(
      name: $name
      email: $email
      messageSubject: $messageSubject
      phone: $phone
      message: $message
    ) {
      status
    }
  }
`;
